import React, { useEffect, useState } from "react";
import {faMapMarkerAlt, faPhone, faShoppingBasket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Style from "./Profile.module.css";
import { getSupplierInfoAPi } from "../../Api/BarestSupplierServices";
import MenuTitle from "../../Components/MenuTitlle/MenuTitle";
import { errorToast } from "../../Utils/Toast/Toast";
const Profile = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    getSupplierInfo();
  }, []);
  //////////// get supplier info /////////////
  const getSupplierInfo = () => {
    getSupplierInfoAPi((succ,res)=>{
      if(succ){
        if(res.status===1){
          setData(res.info)
        }else{
          errorToast(res.message)
        }
      }else{
        console.error(res)
      }
    })
  };
  return (
    <div className={Style.pageHolder}>
      <MenuTitle title={"پروفایل"}/>
      <div className={Style.center}>
        <section className={Style.personInfo}>
          <div className={Style.info}>
            <div className={Style.imgHolder}>
              <img src={"./Assets/Images/Menu/profile.png"} alt=""/>
            </div>
            <h2 className={Style.name}>
              {data.first_name} {data.last_name}
            </h2>
            <p className={Style.phone}>{data.phone}</p>
            {data.telephone?<p className={Style.phone}><FontAwesomeIcon style={{color:"#c20c64",marginLeft:".5rem"}} icon={faPhone}/>{data.telephone}</p>:null}
            <p className={Style.phone}><FontAwesomeIcon style={{color:"#c20c64",marginLeft:".5rem"}} icon={faShoppingBasket}/>{data.name}</p>
            <p className={Style.phone}><FontAwesomeIcon style={{color:"#c20c64",marginLeft:".5rem"}} icon={faMapMarkerAlt}/>{data.address}</p>
            <p className={Style.phone}>شماره شبا :<span style={{color:"#0082ff"}}>{data.iban?data.iban:"ثبت نشده"}</span></p>
            {/* <a href="tel:09114555773" className={Style.support}>
              تماس با پشتیبانی{" "}
              <FontAwesomeIcon className={Style.icon} icon={faPhoneAlt} />
            </a> */}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Profile;
